import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";

import PaymentPage from "./components/Auth/PaymentPage";

function RedirectPaymentToApi() {
  const { search } = useLocation();
  return <Navigate to={"/api/payment" + search} replace />;
}

export default function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/api/payment" element={<PaymentPage />} />
          <Route path="/payment" element={<RedirectPaymentToApi />} />
          <Route path="/pay-challan" element={<PaymentPage />} />
          <Route path="/" element={<PaymentPage />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

